import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import './ArticleInlineCallout.scss';

export const ArticleInlineCallout = ({ node }) => {
    const image = node.field_dark_mode
        ? node.relationships?.field_icon_img?.relationships
              ?.field_image_dark_blue_sticker
        : node.relationships?.field_icon_img?.relationships
              ?.field_image_dark_blue_line;

    const gImage = image ? getImage(image.localFile) : undefined;

    return (
        <section className="article-inline-callout kite-container">
            <div className={node.field_dark_mode ? `dark` : `light`}>
                {gImage && <GatsbyImage alt="" image={gImage} />}
                <div className="content">
                    {node.field_heading && <h3>{node.field_heading}</h3>}
                    {node.field_content_text?.value && (
                        <div
                            className="text"
                            dangerouslySetInnerHTML={{
                                __html: node.field_content_text?.value,
                            }}
                        ></div>
                    )}
                    {node.field_subtitle && (
                        <p className="subtitle">{node.field_subtitle}</p>
                    )}
                    {node.field_subtitle_line2 && (
                        <p className="subtitle-2">
                            {node.field_subtitle_line2}
                        </p>
                    )}
                </div>
            </div>
        </section>
    );
};
